import { render, staticRenderFns } from "./BarangayImportForm.vue?vue&type=template&id=96dca0d8"
import script from "./BarangayImportForm.vue?vue&type=script&lang=js"
export * from "./BarangayImportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports